(function() {
    const searchDrawer = document.getElementById('Search-Drawer');
    if(searchDrawer) {
        searchDrawer.classList.remove('active');
        document.body.classList.remove('open-cc');
    }
})();
const searchBtnEle = document.querySelector(".thb-secondary-area-item.thb-quick-search");
const searchInputEle = document.querySelector(".searchform .search-field");
if(searchBtnEle) {
    searchBtnEle.addEventListener("click",()=>{
        if(searchInputEle) {
            setTimeout(() => {
                searchInputEle.click();
                searchInputEle.focus();
            }, 500);
        }
    });
}
// $('#side-panel-search-input').on('input', function () {
//     const $input = $(this);

//     if ($input.val().trim() === '') {
//         setTimeout(function () {
//             $input.trigger('click');
//         }, 300); // delay in ms
//     }
// });

window.addEventListener("load", function(){
        if (window.location.pathname === '/search') {
            if(window.wizzyLazyAssets)
            {
                window.wizzyLazyAssets.load();
                window.wizzyLazyAssetUtils.isWizzyLazyLoaded = true;
            }
        }
    })


window.onWizzyScriptLoaded = function () {
    const targetNode = document.querySelector(".wizzy-body-end-wrapper");

    function updateBodyClass() {
        const drawer = document.querySelector(".side-panel.search-drawer");
        const isDrawerActive = drawer && drawer.classList.contains("active");

        const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");

        // If drawer is NOT active → hide autocomplete + remove class
        // if (!isDrawerActive) {
        //     if (autocompleteElement) {
        //         autocompleteElement.style.display = "none";
        //     }
        //     document.body.classList.remove("wizzy-autocomplete-open");
        //     return;
        // }

        // Drawer active → check autocomplete normally
        if (
            autocompleteElement &&
            window.getComputedStyle(autocompleteElement).display === "flex"
        ) {
            document.body.classList.add("wizzy-autocomplete-open");
        } else {
            document.body.classList.remove("wizzy-autocomplete-open");
        }
    }

    const config = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"]
    };

    const callback = function (mutationsList) {
        updateBodyClass();
    };

    const observer = new MutationObserver(callback);

    if (targetNode) {
        observer.observe(targetNode, config);
        updateBodyClass();
    }


     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
        if(window?.wizzyConfig?.autocomplete?.menu?.others?.title)
        {
            window.wizzyConfig.autocomplete.menu.others.title = "Popular Searches"
        }
        data.search.configs.general.searchEndpoint = '/search';
        window.wizzyConfig.filters.configs.layout = "v2";
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body #main-content"];
        window.wizzyConfig.search.configs.pagination.appendInExistingList = true;

        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
        data.search.configs.general.searchEndpoint = '/search';
        window.wizzyConfig.filters.configs.layout = "v2";
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body #main-content"];
        window.wizzyConfig.search.configs.pagination.appendInExistingList = true;

        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
        // console.log("BEFORE_SEARCH_EXECUTED");
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body #main-content"];
        let close_btn = document.querySelector('.search-drawer side-panel-close');
        let search_bar = document.querySelector('#side-panel-search-input');
        if(search_bar)
        {
            search_bar.value = '';
        }
        if(close_btn)
        {
            close_btn.click();
        }
        const alreadyExists1 = data.sort.some(
            (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
        );
        if (!alreadyExists1 && data.sort[0].field === "relevance") {
            data.sort.push({ field: "product_wizzy-best-selling_sortOrder:float", order: "asc"});
        }
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
        // console.log("AFTER_PRODUCTS_TRANSFROMED")
        products.forEach((product) => {
            product.wz_images = product.images.slice(1, 4);
            let attributes = product.attributes;
            attributes.forEach((attr) => {
                if(attr.id === "product_handle")
                {
                    let value = attr.values[0].value[0];
                    product.productHandle = value;
                }
            })
        })
        return products;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
        // console.log(data);
        let search_bar = document.querySelector('#side-panel-search-input');
        if(search_bar)
        {
            search_bar.value = '';
        }
        if(data.filters.type === "DEFAULT")
        {
            const Exists = data.filters.sort.some(
                (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
            );

            if (!Exists && data.filters.sort[0].field === "relevance") {
                data.filters.sort.push({ field: "product_wizzy-best-selling_sortOrder:float", order: "asc"});
            }
        }
        const alreadyExists1 = data.filters.sort.some(
            (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
        );
        if (!alreadyExists1 && data.filters.sort[0].field === "relevance") {
            data.filters.sort.push({ field: "product_wizzy-best-selling_sortOrder:float", order: "asc"});
        }
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
        // console.log("View render");
        var inStockBtn = document.querySelector('#wizzy-search-filters-inStock-input');

        if (inStockBtn) {
            // inStockBtn.addEventListener('click', handleButtonClickForInstock);
            inStockBtn.addEventListener('click', handleButtonClickForInstock);
        }
        let apply_btn = document.querySelector('.wizzy-apply-all-button');
        if(apply_btn)
        {
            apply_btn.addEventListener('click', function(){
                let close_btn = document.querySelector('.wizzy-filters-close-btn');
                if(close_btn)
                {
                    close_btn.click();
                }
            })
        }
        let header = document.querySelector('theme-header');
        // console.log("header", header);
        if(header && document.body.classList.contains('wizzy-search-results-rendered'))
        {
            // console.log("Inside header");
            header.classList.remove('transparent--true');
            header.classList.add('transparent--false');
        }
        var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
        // console.log("BEFORE_RENDER_INSTOCK", instockValue);
        if (instockValue) {
        if (instockValue[0] === "true") {
            // console.log("BEFORE_RENDER_INSTOCKCHECK", instockValue);
            var inputForInstock = document.querySelector('#wizzy-search-filters-inStock-input');
            var inputForInstockMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');
            if (inputForInstock) {
            inputForInstock.setAttribute("checked", ""); 
            }
            if (inputForInstockMobile) {
            inputForInstockMobile.setAttribute("checked", ""); 
            }
        }
        }

    //     if (window.innerWidth < 768) {
        
    //     var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

    //   if (sourceElement) {
    //     var clonedContent = sourceElement.cloneNode(true);

    //     var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
    //     if (window.innerWidth < 768) {
    //       if (
    //         targetDiv &&
    //         !targetDiv.querySelector(".wizzy-search-sort-wrapper")
    //       ) {
    //         targetDiv.appendChild(clonedContent);
    //       }
    //     } else {
    //       if (targetDiv) {
    //         var clonedSort = targetDiv.querySelector(
    //           ".wizzy-search-sort-wrapper"
    //         );
    //         if (clonedSort) {
    //           clonedSort.remove();
    //         }
    //       }
    //     }
    //   }

      
    //     const filterHeaderTitle = document.querySelector(
    //       ".wizzy-search-filters-left .wizzy-filters-header .header-title"
    //     );
    //     if (filterHeaderTitle) {
    //       // console.log("Condition executed");
    //       filterHeaderTitle.textContent = "Filter and sort";
    //     }
    //     var sortInFilter = document.querySelector(
    //       ".wizzy-search-filters-left-wrapper .wizzy-sort-wrapper-in-filter"
    //     );

    //     if (
    //       sortInFilter &&
    //       !sortInFilter.classList.contains("click-listener-attached")
    //     ) {
    //       sortInFilter.addEventListener("click", function (event) {
    //         // event.preventDefault();
    //         // event.stopPropagation();
    //         var sortOptions = document.querySelectorAll(
    //           ".wizzy-common-select-options"
    //         );
    //         if (sortOptions) {
    //           if (
    //             sortOptions[1].style.display === "none" ||
    //             sortOptions[1].style.display === ""
    //           ) {
    //             sortOptions[1].style.display = "grid";
    //             sortOptions[0].style.display = "none";
    //           } else {
    //             sortOptions[1].style.display = "none";
    //           }
    //         }
    //       });
    //       sortInFilter.classList.add("click-listener-attached");
    //     }
    //     var hoverElement = document.querySelector(
    //       ".wizzy-common-select-container > .wizzy-common-select-selector"
    //     );

    //     if (
    //       hoverElement &&
    //       !hoverElement.classList.contains("click-listener-attached")
    //     ) {
    //       hoverElement.addEventListener("click", function (event) {
    //         var sortOptions = document.querySelectorAll(
    //           ".wizzy-common-select-options"
    //         );

    //         if (sortOptions.length > 1) {
    //           if (
    //             sortOptions[1].style.display === "none" ||
    //             sortOptions[1].style.display === ""
    //           ) {
    //             sortOptions[1].style.display = "grid";
    //             sortOptions[0].style.display = "none";
    //           } else {
    //             sortOptions[1].style.display = "none";
    //           }
    //         }
    //       });

    //       hoverElement.classList.add("click-listener-attached");
    //     }
    //   }
        return data;
    });
    
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        // console.log("View render");
        document.body.classList.add('wizzy-search-results-rendered');
        let search_bar = document.querySelector('#side-panel-search-input');
        if(search_bar)
        {
            search_bar.value = '';
        }
        var inStockBtn = document.querySelector('#wizzy-search-filters-inStock-input');

        if (inStockBtn) {
            // inStockBtn.addEventListener('click', handleButtonClickForInstock);
            inStockBtn.addEventListener('click', handleButtonClickForInstock);
        }
        let apply_btn = document.querySelector('.wizzy-apply-all-button');
        if(apply_btn)
        {
            apply_btn.addEventListener('click', function(){
                let close_btn = document.querySelector('.wizzy-filters-close-btn');
                if(close_btn)
                {
                    close_btn.click();
                }
            })
        }
        let header = document.querySelector('theme-header');
        // console.log("header", header);
        if(header && document.body.classList.contains('wizzy-search-results-rendered'))
        {
            // console.log("Inside header");
            header.classList.remove('transparent--true');
            header.classList.add('transparent--false');
        }
        var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
        // console.log("BEFORE_RENDER_INSTOCK", instockValue);
        if (instockValue) {
        if (instockValue[0] === "true") {
            // console.log("BEFORE_RENDER_INSTOCKCHECK", instockValue);
            var inputForInstock = document.querySelector('#wizzy-search-filters-inStock-input');
            var inputForInstockMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');
            if (inputForInstock) {
            inputForInstock.setAttribute("checked", ""); 
            }
            if (inputForInstockMobile) {
            inputForInstockMobile.setAttribute("checked", ""); 
            }
        }
        }
        return data;
    });
    
}
// const qs = document.querySelector(".thb-secondary-area-item.thb-quick-search");

// if (qs) {
//     qs.style.pointerEvents = "none";  // disable click initially

//     // Check repeatedly until the drawer exists
//     const interval = setInterval(() => {
//         const drawer = document.querySelector(".side-panel.search-drawer");

//         if (drawer) {
//             qs.style.pointerEvents = "auto"; // enable click
//             clearInterval(interval);         // stop checking
//         }
//     }, 100); // check every 100ms
// }
let outer_input;
if(window.innerWidth > 768)
    outer_input = document.querySelector(".header__search-bar-desktop");
else
    outer_input = document.querySelector(".header__search-bar-mobile");
// console.log("outer input", outer_input);
if(outer_input)
{
    outer_input.addEventListener('click', function(){
        setTimeout(() => {
            let wz_input = document.querySelector(".search-drawer #side-panel-search-input");
            if(wz_input)
            {
                // wz_input.value = "";
                wz_input.click();
            }
        }, 300);
        
    })
}


// if (outer_input) {
//     outer_input.addEventListener("click", () => {

//         // // MOBILE behavior
//         // if (isMobile) {
//         //     setTimeout(() => {
//         //         searchInput?.focus();
//         //     }, 500);
//         //     return;
//         // }

//         // DESKTOP behavior
//         let wz_input = document.querySelector(".search-drawer #side-panel-search-input");
//         setTimeout(() => {
//             const drawer = document.querySelector(".search-drawer");
//             // drawer.style.minHeight = window.innerHeight - 60 + "px";
//             const wizzyWrapper = document.querySelector(".wizzy-body-end-wrapper");

//             if (drawer && wizzyWrapper && !drawer.contains(wizzyWrapper)) {
//                 drawer.appendChild(wizzyWrapper);
//             }
//             if(wz_input)
//             {
//                 wz_input?.focus();
//             }
            
//         }, 500);
//     });
// }

const input = document.getElementById("side-panel-search-input");

if(input)
{
    input.addEventListener("input", function() {
        setTimeout(() => {
            if (this.value.trim() === "") {
                this.click();
            }
        }, 300);
        
    });
}

// document.addEventListener('click', function (event) {
//   const drawer = document.querySelector('.side-panel.search-drawer.active');

//   if (!drawer) return; // Not active, do nothing

//   // Check if click happened outside the drawer
//   if (!drawer.contains(event.target)) {
//     const input = drawer.querySelector('#side-panel-search-input');
    
//     if (input) {
//       input.click();   // trigger click
//       // input.focus(); // (optional) if you want focus instead
//     }
//   }
// });


const drawer = document.querySelector('.side-panel.search-drawer');

if (drawer) {

  function syncBodyClass() {
    if (drawer.classList.contains('active')) {
        setTimeout(() => {
            document.body.classList.add('wz-active');
        }, 300);
    } else {
      document.body.classList.remove('wz-active');
    }
  }

  // Initial check
  syncBodyClass();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        syncBodyClass();
      }
    });
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['class']
  });

} else {
  console.log('Search drawer not found');
}

try {
    

function handleButtonClickForInstock() {
    const currentURL = window.location.href;
    const paramKey = 'inStock[]';
    const paramValue = 'true';

    const updatedURL = updateURL(currentURL, paramKey, paramValue);
    window.executeWizzyFiltersFromURL(updatedURL);
}
function updateURL(url, key, value) {
    const urlObj = new URL(url);
    if (urlObj.searchParams.has(key)) {
        urlObj.searchParams.delete(key);
    } else {
        urlObj.searchParams.append(key, value);
    }

    var newURL = urlObj.toString().replace(/%5B%5D/g, '[]');

    return newURL;
}
} catch (error) {
    console.log(error);
}